var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{},[_c('div',{staticClass:"top-box"},[_c('p',{staticClass:"text"},[_vm._v("亲爱的客户，生日快乐！")]),_c('img',{staticClass:"img-br",attrs:{"src":require("../../assets//iconIndex/srtx_img.png"),"alt":""}}),_c('p',{staticClass:"text2"},[_vm._v("感谢一直以来的信任，愿新岁账户长红，收益如春笋节节高～在这特别的日子里，为你奉上专属心意：")]),_c('div',{staticClass:"top-box-btn"},[_vm._v("去领取")])])])])
}]

export { render, staticRenderFns }